(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerTop = document.querySelector('.contact-info-top');
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.getAttribute('data-sticky-type') === 'none') return;
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    if (this.headerTop) {
      document.documentElement.style.setProperty('--header-top-height', `${this.headerTop.offsetHeight}px`);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(d => d.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

/* Hover-intent for the desktop menu: panels open on hover with a
   small close delay, like apple.com. Touch/keyboard keep the
   default click/focus behavior. */
(() => {
  const mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');
    if (!details || !summary) return;
    let closeTimer = null;

    menu.addEventListener('mouseenter', () => {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      document.querySelectorAll('.header__inline-menu details[open]').forEach((other) => {
        if (other === details) return;
        other.removeAttribute('open');
        const s = other.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      });
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    menu.addEventListener('mouseleave', () => {
      if (!mq.matches) return;
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 160);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerViejo"]) return;
  try {
    
        class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerTop = document.querySelector('.contact-info-top');
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        if (this.getAttribute('data-sticky-type') === 'none') return;
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--header-top-height', `${this.headerTop.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop> this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
            } else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this)); } this.currentScrollTop=scrollTop; } hide() { if
                (this.headerIsAlwaysSticky) return;
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky' );
                this.closeMenuDisclosure(); this.closeSearchModal(); } reveal() { if (this.headerIsAlwaysSticky) return;
                this.header.classList.add('shopify-section-header-sticky', 'animate' );
                this.header.classList.remove('shopify-section-header-hidden'); } reset() { if
                (this.headerIsAlwaysSticky) return;
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky'
                , 'animate' ); } closeMenuDisclosure() { this.disclosures=this.disclosures ||
                this.header.querySelectorAll('header-menu'); this.disclosures.forEach(disclosure=> disclosure.close());
                }

                closeSearchModal() {
                this.searchModal = this.searchModal || this.header.querySelector('details-modal');
                this.searchModal.close(false);
                }
                }

                customElements.define('sticky-header', StickyHeader);
                
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq-DK"] && !Shopify.designMode) return;
  try {
    
class PmaxAccordion extends HTMLElement {
  connectedCallback() {
    this.singleOpen = this.hasAttribute('data-single-open');
    this.items = Array.from(this.querySelectorAll('details.pfaq-item'));
    this.items.forEach((item) => {
      const summary = item.querySelector('summary');
      summary.addEventListener('click', (event) => this.onSummaryClick(event, item));
    });
  }

  get reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  onSummaryClick(event, item) {
    if (this.reducedMotion) return; // let the browser toggle natively

    event.preventDefault();

    if (item.open) {
      this.collapse(item);
    } else {
      if (this.singleOpen) {
        this.items.filter((other) => other !== item && other.open).forEach((other) => this.collapse(other));
      }
      this.expand(item);
    }
  }

  animate(wrap, from, to, onFinish) {
    wrap.style.overflow = 'hidden';
    const animation = wrap.animate(
      { height: [`${from}px`, `${to}px`], opacity: [from ? 1 : 0, to ? 1 : 0] },
      { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    );
    animation.onfinish = () => {
      wrap.style.height = '';
      wrap.style.overflow = '';
      if (onFinish) onFinish();
    };
  }

  expand(item) {
    const wrap = item.querySelector('.pfaq-answer-wrap');
    item.open = true;
    this.animate(wrap, 0, wrap.scrollHeight);
  }

  collapse(item) {
    const wrap = item.querySelector('.pfaq-answer-wrap');
    this.animate(wrap, wrap.scrollHeight, 0, () => {
      item.open = false;
    });
  }
}

if (!customElements.get('pmax-accordion')) {
  customElements.define('pmax-accordion', PmaxAccordion);
}

  } catch(e) { console.error(e); }
})();
})();
